import React, { Component } from "react";
import ComplaintCard from "../../Components/Complaints/ComplaintCard";
import { connect } from "react-redux";
import axios from "axios";
import Header from "../../Components/MainLayout/Header";
import Authorize from "../../../global/Authorize";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class AllComplaints extends Component {
  state = { data: [], loading: true, fakeData: [1, 2, 3, 4] };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Complaint";
    this.fetchcomplain({
      school: this.props.user.user.school.id,
    });
  }

  fetchcomplain = (params = {}) => {
    axios
      .get(`/api/complaint?ordering=-id`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          data: res.data.results,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header to="/home" title="Complaints" />{" "}
        <div className="container my-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton width={150} />
                    <Skeleton count={2} />
                  </div>
                );
              })
            : null}
          {this.state.data.length !== 0 && this.state.loading === false
            ? this.state.data?.map((item, index) => {
                return (
                  <div key={index}>
                    <ComplaintCard
                      title={item.complain}
                      name={item.name}
                      phone={item.phone_no}
                      description={
                        item.message ? item.message : "Action Awaited"
                      }
                      action={item.action}
                      date={item.date}
                    />
                  </div>
                );
              })
            : null}
          {this.state.data.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">No Complaints!</p>
            </div>
          ) : null}
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(AllComplaints);
